import AddBoxIcon from "@mui/icons-material/AddBox";
import LoginIcon from "@mui/icons-material/Login";
import UpdateIcon from "@mui/icons-material/Update";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Skeleton,
  Avatar,
  Divider,
  Chip
} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import PersonIcon from "@mui/icons-material/Person";
import { styled } from "@mui/material/styles";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import * as Yup from "yup";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import Header from "../components/Header";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import { decode } from "base-64";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: 'groove',
  border: '3px',
  borderColor: 'grey',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)',
  marginTop: '10px',  
  marginBottom: '10px',
  minHeight: '50px',
  borderRadius: '10px'
}));


const Cluster = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const cluster_id = location.state && location.state.cluster_id;
  const cluster_name = location.state && location.state.cluster_name;
  const cluster_office = location.state && location.state.cluster_office;
  const society_name = location.state && location.state.society_name;
  const society_id = location.state && location.state.society_id;
  const [societies, setSocieties] = useState([]);
  const [openn, setOpenn] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [cluster_details, setCluster_details] = useState([]);
  const [modal_open, setModal_open] = useState(false);
  const [modal_open_edit, setModal_open_edit] = useState(false);
  const [all_facilitators, setAll_facilitators] = useState([])
  const [openMode, setOpenMode] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [communityToDelete, setCommunityToDelete] = useState(null);
  const [personaInfo, setPersonaInfo] = useState([]);

  const handleDeleteClick = (community_id) => {
    setCommunityToDelete(community_id);
    setDeleteModalOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (communityToDelete) {
      deleteCommunity(communityToDelete);
    }
    setDeleteModalOpen(false);
    setCommunityToDelete(null);
  };

  const handleDeleteCancel = () => {
    setDeleteModalOpen(false);
    setCommunityToDelete(null);
  };

  const deleteCommunity = (community_id) => {
    toast.promise(
      api
      .get(
        `/association/delete/community/${community_id}`,
        {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }
      ),
      {
          loading: "Deleting Community And Related Contents...",
          success: (response) => {
              fetch_cluster_details();
              fetch_societies();
              fetch_facilitators();
              return response.data
          },
          error: (error) => {
              console.log(error);
              
              return 'Error, Please try again'
          }
      }
    )
  }



  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };


  const aggre_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 520,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
};


  const new_data = () => {
    toast.promise(
      api.get(`/association/get/one/cluster/${cluster_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      }),
      {
        loading: 'Loading cluster data...',
        success: (res) => {
          const clusterDetails = res.data;
          setCluster_details(clusterDetails);
          localStorage.setItem(`cluster_details_${cluster_id}`, JSON.stringify(clusterDetails));
          return 'Action Successful'
        },
        error: (err) => {
          console.log(err)
          return 'An Error Occurred'
        }
      }
    )
  }

  
  const removeFacilitator = (id) => {
    const data = new FormData()
    data.append('cluster_id', cluster_id)
    data.append('facilitator_id', id)

      api
    .post("/account/delete/facilitator/multiple", data, {
      headers: {
        Authorization: "Bearer " + fetchToken(),
      },
    })
    .then(function (response) {
      toast.success(response.data);
      new_data()
    })
    .catch(function (error) {
      console.log(error);
    });
  }

  const handleNewFacilis = (id) => {
    const data = new FormData()
    data.append('cluster_id', cluster_id)
    data.append('facilitator_id', id)

    api
  .post("/account/set/facilitator/multiple", data, {
    headers: {
      Authorization: "Bearer " + fetchToken(),
    },
  })
  .then(function (response) {
    toast.success(response.data);
    setOpenMode(false)
    new_data()
  })
  .catch(function (error) {
    console.log(error);
  });
}


  const fetch_facilitators = () => {
    const storedFacilis = localStorage.getItem('facilis');

    if (storedFacilis) {
        setAll_facilitators(JSON.parse(storedFacilis));
    } else {
      api
          .get("/account/all/facilitators", {
              headers: {
              Authorization: "Bearer " + fetchToken(),
              },
          })
          .then(function (response) {
              setAll_facilitators(response.data?.facilitators);
              localStorage.setItem('facilis', JSON.stringify(response.data?.facilitators));
          })
          .catch(function (error) {
              console.log(error);
          });
    }
  }

  const closeam = () => {
    setModal_open(false);
  };
  const closeam_edit = () => {
    setModal_open_edit(false);
  };

  const sec_style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 320,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const sec_style_edit = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 620,
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    border: "1px solid #e7ecef",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  const handleCloses = () => {
    setOpenn(false);
  };
  const handleOpen = () => {
    setOpenn(true);
  };

  const fetch_societies = () => {
    const cachedSocieties = localStorage.getItem('societies');
    if (cachedSocieties) {
      setSocieties(JSON.parse(cachedSocieties));
    } else {
      api
        .get("/association/societies/allshch", {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const societiesData = response?.data?.Society;
          setSocieties(societiesData);
          localStorage.setItem('societies', JSON.stringify(societiesData));
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  

  const fetch_cluster_details = () => {
    const cachedClusterDetails = localStorage.getItem(`cluster_details_${cluster_id}`);
    if (cachedClusterDetails) {
      setCluster_details(JSON.parse(cachedClusterDetails));
    } else {
      api
        .get(`/association/get/one/cluster/${cluster_id}`, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          const clusterDetails = response.data;
          setCluster_details(clusterDetails);
          localStorage.setItem(`cluster_details_${cluster_id}`, JSON.stringify(clusterDetails));
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    api
      .get("/users/su", {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setPersonaInfo(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  
  useEffect(() => {
    fetch_cluster_details();
    fetch_societies();
    fetch_facilitators();
  }, [cluster_id]);

  const formik = useFormik({
    initialValues: {
      community_name: "",
    },
    validationSchema: Yup.object({
      community_name: Yup.string().required(
        "Community name should not be empty"
      ),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("community_name", values.community_name);
      data.append("cluster_id", cluster_id);

      api
        .post("/association/create/community", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          fetch_cluster_details();
          formik.handleReset();
          closeam();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
        });
    },
  });

  const formik_edit = useFormik({
    initialValues: {
      cluster_name: cluster_name,
      cluster_office: cluster_office,
      society: society_id,
    },
    validationSchema: Yup.object({
      cluster_name: Yup.string().required("Cluster name should not be empty"),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const data = new FormData();
      data.append("cluster_name", values.cluster_name);
      data.append("cluster_id", cluster_id);
      data.append("cluster_office", values.cluster_office);
      data.append("society_id", values.society);
      api
        .post("/association/change/cluster", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          fetch_cluster_details();
          closeam_edit();
          formik_edit.handleReset();
        })
        .catch(function (error) {
          console.log(error);
        })
        .finally(function () {
          setLoading(false);
        });
    },
  });

  const visit_community = (id, community_name) => {
    navigate("/community", {
      state: {
        community_id: id,
        cluster_name: cluster_name,
        society_id: society_id,
        society_name: society_name,
        community_name: community_name,
      },
    });
  };
  if (cluster_details) {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 5 }}>
            <Box display="flex" alignItems="center">
              {/* <IconButton
                onClick={() => navigate(-1)}
                type="button"
                sx={{ p: 1 }}
              >
                <KeyboardBackspaceIcon />
              </IconButton> */}
              <Header title="Cluster Details" />
            </Box>
            <Box>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <Typography
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    variant="h3"
                    textAlign="center"
                  >
                    <b>{cluster_details?.cluster?.cluster_name}</b>
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4} sx={{ mb:10 }}>
                  <Item>
                    <Box sx={{ display: "block" }}>
                      <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        Cluster Office:{" "}
                        <b>{cluster_details?.cluster?.cluster_office}</b>
                      </Typography>
                      <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        Cluster Society:{" "}
                        <b>
                          {typeof society_name === "string" &&
                          society_name.includes("Society" || "society")
                            ? society_name
                            : `${society_name} Society`}
                        </b>
                      </Typography>
                      <Typography sx={{ m: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        Number of communities:{" "}
                        <b>
                          {Array.isArray(cluster_details?.communities) &&
                            cluster_details?.communities.length}
                        </b>
                      </Typography>
                      <Typography
                        sx={{ m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                        variant="subtitle"
                      >
                        <b>Update Cluster</b>
                        <IconButton onClick={() => setModal_open_edit(true)}>
                          <UpdateIcon />
                        </IconButton>
                      </Typography>
                          <Typography
                            sx={{ m: 1 }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant="subtitle"
                          >
                            <b>Create community</b>
                            <IconButton onClick={() => setModal_open(true)}>
                              <AddBoxIcon />
                            </IconButton>
                          </Typography>

                        <Box sx={{ display:'flex', flexDirection:'column' }}>
                          <Typography
                            sx={{ m: 1, textAlign:'center', display:'flex', flexDirection:'column' }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant="subtitle"
                          >
                            <b>Facilitators <IconButton onClick={() => setOpenMode(true)}>
                              <PersonIcon />
                            </IconButton></b>
                          </Typography>
                          <Divider />
                          
                          <Typography
                            sx={{ m: 1 }}
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            variant="subtitle"
                          >
                            <b>Main: {cluster_details?.facilitator?cluster_details?.facilitator: 'Not set'}</b>
                          </Typography>
                            <List>
                                {
                                cluster_details?.facilitators &&
                                cluster_details?.facilitators.map((facilitator) => (
                                  <ListItem key={facilitator.id}>
                                    <ListItemText
                                    primary={facilitator.username}
                                    secondary={
                                      <Chip 
                                        key={facilitator.id} 
                                        size='small'
                                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Remove</b></Typography>}
                                        sx={{
                                          borderRadius:2,
                                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                          backgroundColor:'#780000',
                                          color:'#fff',
                                          '&:hover': {
                                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                          },
                                        }} 
                                        onClick={() => removeFacilitator(facilitator.id)} 
                                      />
                                    }
                                  />
                                  </ListItem>
                                ))
                              }  
                            </List>
                          
                          
                        </Box>

                      
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} md={8}>
                  <Item>
                    <Typography
                      sx={{ textAlign: "center" }}
                      variant="h5"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Communities</b>
                    </Typography>
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        maxHeight: 450,
                        overflowY: "scroll",
                      }}
                    >
                      {cluster_details?.communities &&
                        cluster_details?.communities?.map((community) => (
                          <Card
                            sx={{
                              width: 180,
                              margin: 4,
                              borderRadius: "15px",
                            }}
                          >
                            <CardContent>
                              <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                              >
                                <b>{community.community_name}</b>
                              </Typography>
                            </CardContent>
                            <CardActions>
                              {personaInfo?.role_name === 'Administrator'?
                                <Button
                                    size="small"
                                    color="error"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    mr: 'auto',
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleDeleteClick(community.community_id)}
                                >
                                    <DeleteRoundedIcon />
                                </Button>
                                :null}
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    mr: 'auto',
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => visit_community(
                                      community.community_id,
                                      community.community_name
                                    )}
                                >
                                    <Typography
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                        <b>View</b>
                                    </Typography>
                                </Button>
                            </CardActions>
                          </Card>
                        ))}
                    </div>
                  </Item>
                </Grid>
              </Grid>

              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={openn}
                onClick={handleCloses}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Modal
                open={modal_open}
                onClose={closeam}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={sec_style}>
                  <Typography sx={{ textAlign: "center" }} fontStyle="oblique">
                    <b>New Community</b>
                  </Typography>
                  <form onSubmit={formik.handleSubmit}>
                    <div style={{ margin: "5px" }}>
                      <TextField
                        size="small"
                        value={formik.values.community_name}
                        name="community_name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.community_name &&
                          Boolean(formik.errors.community_name)
                        }
                        helperText={
                          formik.touched.community_name &&
                          formik.errors.community_name
                        }
                        sx={{ m: 1 }}
                        variant="outlined"
                        label="Community Name"
                      />
                    </div>

                    <div style={{ display: "flex" }}>
                      <Button
                        sx={{ m: 1 }}
                        size="small"
                        variant="contained"
                        color="error"
                        onClick={closeam}
                      >
                        Cancel
                      </Button>
                      <Button
                        sx={{ m: 1 }}
                        type="submit"
                        size="small"
                        variant="contained"
                        color="success"
                        disabled={loading}
                      >
                        {loading === true ? (
                          <CircularProgress color="info" size="20px" />
                        ) : (
                          "Create"
                        )}
                      </Button>
                    </div>
                  </form>
                </Box>
              </Modal>
              <Modal
                open={modal_open_edit}
                onClose={closeam_edit}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={sec_style_edit}>
                  <Typography sx={{ textAlign: "center" }} fontStyle="oblique">
                    <b>Update Cluster</b>
                  </Typography>

                  {cluster_details && cluster_details ? (
                    <form onSubmit={formik_edit.handleSubmit}>
                      <div style={{ margin: "5px" }}>
                        <TextField
                          size="small"
                          value={formik_edit.values.cluster_name}
                          name="cluster_name"
                          onChange={formik_edit.handleChange}
                          onBlur={formik_edit.handleBlur}
                          error={
                            formik_edit.touched.cluster_name &&
                            Boolean(formik_edit.errors.cluster_name)
                          }
                          helperText={
                            formik_edit.touched.cluster_name &&
                            formik_edit.errors.cluster_name
                          }
                          sx={{ m: 1 }}
                          variant="outlined"
                          label="Cluster Name"
                        />
                        <TextField
                          size="small"
                          value={formik_edit.values.cluster_office}
                          name="cluster_office"
                          onChange={formik_edit.handleChange}
                          sx={{ m: 1 }}
                          variant="outlined"
                          label="Office Address"
                        />
                        <Select
                          size="small"
                          value={formik_edit.values.society}
                          name="society"
                          onChange={formik_edit.handleChange}
                          sx={{ m: 1 }}
                          variant="outlined"
                        >
                          <MenuItem key={0} value={0}>
                            Change Society
                          </MenuItem>
                          {societies.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {item.society}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>

                      <div style={{ display: "flex" }}>
                        <Button
                          sx={{ m: 1 }}
                          size="small"
                          variant="contained"
                          color="error"
                          onClick={closeam_edit}
                        >
                          Cancel
                        </Button>
                        <Button
                          sx={{ m: 1 }}
                          type="submit"
                          size="small"
                          variant="contained"
                          color="success"
                          disabled={loading}
                        >
                          {loading === true ? (
                            <CircularProgress color="info" size="20px" />
                          ) : (
                            "Update"
                          )}
                        </Button>
                      </div>
                    </form>
                  ) : (
                    <CircularProgress sx={{ textAlign: "center" }} />
                  )}
                </Box>
              </Modal>

              <Modal
            open={openMode}
            onClose={() => setOpenMode(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={aggre_style}>
              {all_facilitators ? (
                <List
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    bgcolor: "background.paper",
                  }}
                >
                  {all_facilitators.map((item) => (
                    <>
                      <ListItem
                        alignItems="flex-start"
                        onClick={() => handleNewFacilis(item.user_id)}
                        sx={{ cursor:'pointer' }}
                        // secondaryAction={
                        //   <IconButton
                        //     onClick={() => handleNewFacilis(item.user_id)}
                        //     edge="end"
                        //     aria-label="comments"
                        //   >
                        //     <CheckCircleIcon
                        //       color={
                        //         item.fullname === facilitator
                        //           ? "success"
                        //           : "primary"
                        //       }
                        //     />
                        //   </IconButton>
                        // }
                      >
                        <ListItemAvatar>
                          <Avatar
                            alt="facilitator"
                            src={pic(item.picture_img)}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          primary={item.fullname}
                          secondary={
                            <Box sx={{ display: "block" }}>
                              <div>
                                <Typography
                                  sx={{ display: "inline" }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Contact: <b>{item.phone}</b>
                                </Typography>
                              </div>
                              <div>
                                <Typography
                                  sx={{ display: "inline" }}
                                  variant="body2"
                                  color="text.primary"
                                >
                                  Society: <b>{item.society}</b>
                                </Typography>
                              </div>
                            </Box>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </>
                  ))}
                </List>
              ) : (
                <Box sx={{ display: "flex", textAlign: "center" }}>
                  <Typography>No Facilitators found</Typography>
                </Box>
              )}
            </Box>
          </Modal>
            </Box>
          </Box>
          {/* Delete Confirmation Modal */}
          <Dialog
            open={deleteModalOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirm Deletion"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this community? This action cannot be undone and will permanently delete all associated data including transactions and member records.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteCancel} color="primary">
                Cancel
              </Button>
              <Button 
                onClick={handleDeleteConfirm} 
                color="error"
                autoFocus
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </main>
      </div>
    );
  } else {
    return (
      <div className="app">
        <main className="content">
          <Box sx={{ m: 3 }}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title="Cluster" />
            </Box>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width={410}
                  height={160}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width={710}
                  height={260}
                />
              </Grid>
            </Grid>
          </Box>
          {/* Delete Confirmation Modal */}
          <Dialog
            open={deleteModalOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Confirm Deletion"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this community? This action cannot be undone and will permanently delete all associated data including transactions and member records.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDeleteCancel} color="primary">
                Cancel
              </Button>
              <Button 
                onClick={handleDeleteConfirm} 
                color="error"
                autoFocus
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        </main>
      </div>
    );
  }
};

export default Cluster;
